import { Card, Descriptions } from 'antd';
import { useTranslation } from 'react-i18next';
import { type AudiCalculationModuleSpecsFragment } from '../../../../api/fragments/AudiCalculationModuleSpecs';

type AudiCalculationModuleTabAuthorizationProps = {
    module: AudiCalculationModuleSpecsFragment;
};

const AudiCalculationModuleTabAuthorization = ({ module }: AudiCalculationModuleTabAuthorizationProps) => {
    const { t } = useTranslation(['audiCalculationModuleDetails']);

    return (
        <Card>
            <Descriptions column={{ xs: 1, md: 2 }} bordered>
                <Descriptions.Item label={t('audiCalculationModuleDetails:tabs.authorization.descriptions.accessKey')}>
                    {module.authorization.accessKey}
                </Descriptions.Item>
                <Descriptions.Item label={t('audiCalculationModuleDetails:tabs.authorization.descriptions.secretKey')}>
                    {module.authorization.secretKey}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default AudiCalculationModuleTabAuthorization;
